// extracted by mini-css-extract-plugin
module.exports = {"renoResultImage":"RenoResultImage_renoResultImage__2kPps"};